module.exports = __webpack_public_path__ + "f352a39a5cc24f171a7281d41ce28d5b.svg";